export default __webpack_public_path__ + "static/media/icon-cloud-upload-wei.87eaff78.svg";